const apiUrl = process.env.REACT_APP_URL_API;
const apiKey = process.env.REACT_APP_API_KEY;

interface RegisterResponse {
    message: string;
    // altri campi di risposta, se presenti
}

interface LoginResponse {
    accessToken: string;
    email: string;
    nome: string;
}

export const info = async (accessToken: string): Promise<LoginResponse> => {
    const response = await fetch(`${apiUrl}/identity/manage/info`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            "X-API-KEY": apiKey || "",
            'Authorization': `Bearer ${accessToken}`, // Aggiungi l'header Authorization
        }
    });
    if (!response.ok) {
        throw new Error('Errore durante il login');
    }
    return await response.json();
};

export const logout = async (): Promise<boolean> =>{

    const response = await fetch(`${apiUrl}/logout`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-API-KEY": apiKey || "",
        },
        credentials: "include",
        body: ""
    });
    if (!response.ok) {
        throw new Error('Errore durante il logout');
    }
    return await true;
};


export const login = async (rememberMe: string, email: string, password: string): Promise<Response> => {
    
    const response = await fetch(`${apiUrl}/login?${rememberMe}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            "X-API-KEY": apiKey || "",
        },
        body: JSON.stringify({
            email: email,
            password: password,
        }),
    });
    return await response;
};

